import { Component, OnInit, OnDestroy, HostBinding } from "@angular/core";
import noUiSlider from "nouislider";
import { WpService } from '../../wp.service';
import { Observable } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { Router, RouterLink, NavigationEnd } from '@angular/router';
import { NgSwitch } from "@angular/common";
import { trigger, transition, style, animate } from "@angular/animations";




  


@Component({
  selector: "app-index",
  templateUrl: "index.component.html",
  animations: [
    trigger('carouselAnimation', [
      transition('void => *', [
        style({ opacity: 0 }),
        animate('300ms', style({ opacity: 1 }))
      ]),
      transition('* => void', [
        animate('300ms', style({ opacity: 0 }))
      ])
    ])
  ]
})



export class IndexComponent implements OnInit, OnDestroy {
  

  
   
  isCollapsed = true;
  focus;
  focus1;
  focus2;
  date = new Date();
  pagination = 3;
  pagination1 = 1;
  textoNeforeal = "1er INSTITUTO MODELO DE NEFROLOGIA HEMODIALISIS.\n COLOCACIÓN DE CATETER SESIÓN DE HEMODIALISIS CRÓNICA. \nEl afiliado debe solicitar autorización por Auditoría Médica.\nDOSPU reconoce el 100%."
  contactoVariable = '#contacto'
  id: any;
  noticiaD:any;
  feed: Observable<any[]>;
  feedDestacado: Observable<any[]>;
  constructor(private wp: WpService, private route: ActivatedRoute, private router: Router) { 
    this.feed = this.wp.getPosts();
    this.feedDestacado = this.wp.getPostsDestacado();
    /*this.route.url.subscribe(u => {
      this.id = this.route.snapshot.params.id;
    });*/
  }  
  
  scrollTo(element: any) {
    element.scrollIntoView({ behavior: "smooth" });
  }
  ngOnInit() {
    
   /* this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
          return;
      }
      window.scrollTo(0, 0)
  });*/
  

    this.singlePost();
    
    var body = document.getElementsByTagName("body")[0];
    body.classList.add("index-page");

    var slider = document.getElementById("sliderRegular"); 

    var slider2 = document.getElementById("sliderDouble");

    noUiSlider.create(slider2, {
      start: [20, 60],
      connect: true,
      range: {
        min: 0,
        max: 100
      }
    });
  }

  private singlePost() {
    this.wp.getSinglePost(this.id).subscribe(
      data => {
        this.noticiaD = data;
      }
    );
  }

  ngOnDestroy() {
    var body = document.getElementsByTagName("body")[0];
    body.classList.remove("index-page");
  }

  
}


 
